module.exports = __webpack_public_path__ + "static/media/pw.26d40194.png";